import React from 'react';
import PropTypes from 'prop-types';

const QuizProgress = ({ currentQuestionIndex, totalQuestions }) => {
  const progressPercentage = ((currentQuestionIndex + 1) / totalQuestions) * 100;

  return (
    <div className="mb-6">
      <div className="w-full bg-purple-100 rounded-full h-2.5">
        <div
          className="bg-purple-600 h-2.5 rounded-full transition-all duration-300"
          style={{ width: `${progressPercentage}%` }}
        />
      </div>
      <p className="text-right text-sm text-purple-600 mt-1">
        {currentQuestionIndex + 1} / {totalQuestions}問
      </p>
    </div>
  );
};

QuizProgress.propTypes = {
  currentQuestionIndex: PropTypes.number.isRequired,
  totalQuestions: PropTypes.number.isRequired,
};

export default QuizProgress; 